import { SkinnableComponent } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import { useTrendingItemsLogic } from './TrendingItemsLogic';
import BasicTrendingItemsSkin from './skins/BasicTrendingItemsSkin';

/**
 * TrendingItems 스킨 가능 컴포넌트 정의
 */
export const TrendingItemsSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.TRENDING_ITEMS || 'TRENDING_ITEMS',
  name: '트렌딩 아이템',
  category: 'content',
  supportsExternalSkins: true,
  options: [],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicTrendingItemsSkin as any
  },
  useLogic: useTrendingItemsLogic as any,
  defaultProps: {
    mainTitle: 'Trending now',
    subtitle: '에디터가 선정한',
    is_logged: true,
    is_not_logged: true,
    imageRadius: '4px',
    showMoreButton: true,
    moreButtonText: 'MORE',
    moreButtonUrl: '#',
    moreButtonTextColor: '#8a7a6d',
    moreButtonBorderColor: '#8a7a6d',
    moreButtonBgColor: 'transparent',
    moreButtonHoverTextColor: '#ffffff',
    moreButtonHoverBgColor: '#8a7a6d',
    items: [],
    componentProps: {
      mainTitle: 'Trending now',
      subtitle: '에디터가 선정한',
      is_logged: true,
      is_not_logged: true,
      imageRadius: '4px',
      showMoreButton: true,
      moreButtonText: 'MORE',
      moreButtonUrl: '#',
      moreButtonTextColor: '#8a7a6d',
      moreButtonBorderColor: '#8a7a6d',
      moreButtonBgColor: 'transparent',
      moreButtonHoverTextColor: '#ffffff',
      moreButtonHoverBgColor: '#8a7a6d',
      items: []
    }
  }
};